import React, { useContext, useState } from 'react';
import { AuthContext } from 'context';
import { Button, Col, Form, Input, Modal, Row, Table } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import { EditOutlined } from '@ant-design/icons';

const UserInformation = () => {
  const context = useContext(AuthContext);
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [loading] = useState(false);
  const [user] = useState([
    {
      Email: context.currentUser?.email,
      Password: '******',
    },
  ]);

  const columns = [
    {
      title: 'E-mail',
      dataIndex: 'Email',
      key: 'Email',
      align: 'left',
      width: 100,
    },
    {
      title: 'Şifre',
      dataIndex: 'Password',
      key: 'text',
      align: 'left',
      width: 100,
    },
    {
      title: 'İşlemler',
      dataIndex: 'identifier',
      key: 'actions',
      fixed: 'right',
      align: 'center',
      width: 200,
      render: () => (
        <div>
          <Button
            className="mr-3"
            type="ghost"
            onClick={() => {
              setVisible(true);
              form.setFieldsValue({
                Email: context.currentUser?.email,
                Password: '******',
              });
            }}
          >
            <EditOutlined />
          </Button>
        </div>
      ),
    },
  ];

  const handleCloseForm = () => {
    setVisible(false);
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      console.log('Updated Values:', values);
      setVisible(false);
    } catch (err) {
      console.error('Validation Failed:', err);
    }
  };

  return (
    <PageContainer title="Kullanıcı Bilgileri">
      <Table
        loading={loading}
        dataSource={user}
        columns={columns}
        pagination={false}
        rowKey="Email"
      />

      <Modal
        title="Kullanıcı Bilgilerini Güncelleme"
        open={visible}
        okText="Güncelle"
        onOk={handleSubmit}
        onCancel={handleCloseForm}
        destroyOnClose
      >
        <Form form={form} layout="vertical">
          <Row>
            <Col span={24}>
              <Form.Item
                name="Email"
                label="E-mail"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Input className="input__default" placeholder="E-mail" />
              </Form.Item>
              <Form.Item
                name="Password"
                label="Parola"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Input.Password className="input__default" placeholder="Parola" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </PageContainer>
  );
};

export default UserInformation;
